import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Card,
  CardMedia,
  CardContent,
  IconButton,
  Stack,
  useTheme,
} from "@mui/material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BlogDetailsScreen from "./BlogDetailsScreen";
import { fetchAllBlogs } from "../../../apiservices/ApiService";

const AllTipsScreen = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBlogUrl, setSelectedBlogUrl] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        const data = await fetchAllBlogs();
        setBlogs(data.blogs || []);
      } catch (error) {
        console.error("Error loading blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    loadBlogs();
  }, []);

  if (selectedBlogUrl) {
    return (
      <BlogDetailsScreen
        blogUrl={selectedBlogUrl}
        onBack={() => setSelectedBlogUrl(null)}
      />
    );
  }

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: theme.spacing(2), backgroundColor: "rgba(255, 152, 0, 0.11)", }}>
      {blogs.map((blog, index) => (
        <Card
          key={index}
          variant="outlined"
          onClick={() => setSelectedBlogUrl(blog.blogUrl)}
          sx={{
            marginBottom: theme.spacing(2),
            boxShadow: theme.shadows[1],
            cursor: "pointer",
            background: "linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.2) 100%)",
            border: "1px solid #771615",
          }}
        >
          <CardMedia
            component="img"
            image={blog.blogImage}
            alt={blog.blogTitle}
            sx={{ height: 200, objectFit: "cover" }}
          />
          <CardContent>
            <Typography
              variant="body1"
              fontWeight="bold"
              sx={{ marginBottom: theme.spacing(1), color: "#771615" }}
            >
              {blog.blogTitle}
            </Typography>
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{ marginBottom: theme.spacing(1), display: "block" }}
            >
              {blog.blogRead} Reads • {blog.minsToRead} min read
            </Typography>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="caption"
                color="primary"
                component="a"
                href={blog.blogUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "#771615", fontWeight: "bold", fontSize: "14px" }}
              >
                Read More
              </Typography>
              <IconButton>
                {blog.bookmarkedByMe === "Y" ? (
                  <BookmarkIcon color="primary" />
                ) : (
                  <BookmarkBorderIcon />
                )}
              </IconButton>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default AllTipsScreen;